module.exports = __webpack_public_path__ + "static/img/05.c1465ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news22/05.png
// module id = A4SQ
// module chunks = 1